module.exports = __webpack_public_path__ + "img/avo.46ed778d.jpeg";